export default {
  nav: {
    home: 'Home',
    about: 'About Us',
    programs: 'Programs',
    donate: 'Donate',
    contact: 'Contact',
  },
  hero: {
    badge: 'Persatuan Insani Darul Hana Kuching',
    title1: 'Light of Hope',
    title2: 'for Our Community',
    subtitle:
      'We uplift the less fortunate in Kuching through charity, donations and skills training — building a brighter future, one life at a time.',
    donate: 'Donate Now',
    programs: 'Explore Programs',
    regNo: 'Registration No. PPM-003-13-12082021',
  },
  stats: {
    tag: 'Our Impact',
    title: 'Every contribution creates real change',
    subtitle:
      'Since our registration in 2021, we have walked alongside families and individuals in need across Kuching, Sarawak.',
    value1: '5,000+',
    label1: 'Lives Touched',
    value2: '120+',
    label2: 'Families Assisted',
    value3: '350+',
    label3: 'People Trained',
    value4: '40+',
    label4: 'Active Volunteers',
  },
  about: {
    tag: 'Who We Are',
    title: 'A registered welfare organisation serving the community',
    p1: 'Persatuan Insani Darul Hana Kuching is a registered welfare organisation under the Registrar of Societies Malaysia. Based in Petra Jaya, Kuching, Sarawak, we are dedicated to easing the burdens of the underprivileged and empowering individuals to become self-reliant.',
    p2: 'Guided by compassion and responsibility, we channel kindness into meaningful action — from delivering essential aid to equipping people with skills that open doors to a better livelihood.',
    mission: 'Mission',
    missionText:
      'To provide welfare aid, donations and skills training that uplift the quality of life of the less fortunate.',
    vision: 'Vision',
    visionText:
      'To build a caring, self-sufficient community where no one is left behind.',
    value1: 'Compassion',
    value2: 'Integrity',
    value3: 'Empowerment',
    reg: 'Registered under Akta Pertubuhan 1966',
  },
  programs: {
    tag: 'What We Do',
    title: 'Three pillars of giving back',
    subtitle:
      'Our work focuses on three core areas that together create lasting change for the community.',
    learnMore: 'Learn more',
    charity: {
      title: 'Charity Aid',
      desc: 'Distributing food aid and essential supplies to underprivileged families, the elderly, single mothers and orphans across Kuching, Sarawak.',
    },
    donation: {
      title: 'Donation & Infaq',
      desc: 'Collecting and channelling zakat, sadaqah and general donations into monthly aid, festive giving and community relief programmes.',
    },
    training: {
      title: 'Skills Training',
      desc: 'Empowering people with sewing, cooking, digital and entrepreneurship skills to build sustainable livelihoods.',
    },
  },
  donate: {
    tag: 'Donate',
    title: 'Your generosity changes lives',
    subtitle:
      'Every ringgit brings food to a hungry family, skills to a job-seeker, and hope to someone in need. You can contribute directly via bank transfer.',
    bank: 'Bank Transfer',
    accountName: 'Account Name',
    accountNameValue: 'Persatuan Insani Darul Hana Kuching',
    accountNo: 'Account Number',
    accountNoValue: '8881025568741',
    bankName: 'Bank',
    bankNameValue: 'AmBank',
    note: 'Kindly email your transfer receipt to contact@insanidarulhanakuching.org so we can acknowledge your contribution.',
    cta: 'Volunteer With Us',
  },
  testimonials: {
    tag: 'Testimonials',
    title: 'Stories of hope and gratitude',
    subtitle: 'Hear from the people whose lives have been touched by the kindness of our donors and volunteers.',
    quote1:
      'Thanks to Insani Darul Hana’s food aid programme, my family never goes hungry during difficult times.',
    name1: 'Siti Aisyah',
    role1: 'Single Mother, Aid Recipient',
    quote2:
      'The sewing training changed my life. I now earn a living from home and support my children.',
    name2: 'Rosnah binti Hassan',
    role2: 'Skills Training Graduate',
    quote3:
      'Volunteering here taught me the true power of giving back to the community.',
    name3: 'Ahmad Firdaus',
    role3: 'Volunteer',
  },
  contact: {
    tag: 'Get Involved',
    title: 'Reach out or lend a hand',
    subtitle:
      'Have a question, want to donate, or wish to volunteer? We would love to hear from you.',
    addressLabel: 'Address',
    address: 'No. 18, Lorong Astana 3, Jalan Astana, Petra Jaya, 93050 Kuching, Sarawak',
    phoneLabel: 'Phone',
    phone: '+6012-5478388',
    emailLabel: 'Email',
    email: 'contact@insanidarulhanakuching.org',
    formTitle: 'Send us a message',
    formSubtitle: 'Fill in the form and our team will get back to you shortly.',
    name: 'Full Name',
    namePlaceholder: 'Your name',
    emailField: 'Email Address',
    emailPlaceholder: 'you@example.com',
    phoneField: 'Phone Number',
    phonePlaceholder: 'e.g. +60 12-345 6789',
    subject: 'Subject',
    subjectPlaceholder: 'How can we help?',
    message: 'Message',
    messagePlaceholder: 'Write your message here…',
    submit: 'Send Message',
    sending: 'Sending…',
    success: 'Thank you! Your message has been sent. We will get back to you soon.',
    error: 'Something went wrong. Please try again.',
    volunteerTitle: 'Become a volunteer',
    volunteerSubtitle: 'Share your time and skills to make a difference in your community.',
    areaLabel: 'Area of interest',
    area1: 'Food aid distribution',
    area2: 'Skills training',
    area3: 'Fundraising & events',
    area4: 'General help',
    availabilityLabel: 'Availability',
    availabilityPlaceholder: 'e.g. weekends, evenings',
    volunteerMessage: 'Tell us about yourself',
    volunteerMessagePlaceholder: 'Share your skills and experience…',
    volunteerSubmit: 'Register as Volunteer',
  },
  footer: {
    tagline:
      'A registered welfare organisation dedicated to charity, donations and skills training for the community of Kuching, Sarawak.',
    quickLinks: 'Quick Links',
    programs: 'Our Programs',
    contact: 'Contact Us',
    rights: 'All rights reserved.',
    regNo: 'Registration No. PPM-003-13-12082021',
  },
};